import { render, staticRenderFns } from "./CurrentAlarmSocket.vue?vue&type=template&id=2e8f1a97&scoped=true&"
import script from "./CurrentAlarmSocket.vue?vue&type=script&lang=js&"
export * from "./CurrentAlarmSocket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8f1a97",
  null
  
)

export default component.exports